import React from 'react'
import { default as EditUser } from '../../users/Edit'
import { tableCollumns as tableUserCollumns } from '../../users/Users'
import { default as EditResource } from '../../resources/Edit'
import { tableCollumns as tableResourceCollumns } from '../../resources/Resources'
import { default as EditProject } from '../../projects/Edit'
import { tableCollumns as tableProjectCollumns } from '../../projects/Projects'
import { useGlobalState, getGlobalState } from '../../store'
import { setRemoteCall } from '../../remote'

export default function BoardsModals() {
  const [openUserModal, setOpenUserModal] = useGlobalState('openUserModal')
  console.log('openUserModal', openUserModal)
  const [openResourceModal, setOpenResourceModal] = useGlobalState(
    'openResourceModal'
  )
  const [openProjectModal, setOpenProjectModal] = useGlobalState(
    'openProjectModal'
  )

  // const [resourceTypes, setResourceTypes] = useGlobalState('resourceTypes')
  const resourceTypes = getGlobalState('resourceTypes')
  const userTypes = getGlobalState('userTypes')

  /**
   * Set table data
   */
  const set = (data, notice, type) => {
    if (type === 'users') setRemoteCall('setUsers', data, notice)
    if (type === 'projects') setRemoteCall('setProjects', data, notice)
    if (type === 'resources') setRemoteCall('setResources', data, notice)
  }

  return (
    <>
      {openProjectModal && (
        <EditProject
          data={openProjectModal}
          form={tableProjectCollumns}
          set={set}
          setOpenModal={setOpenProjectModal}
        />
      )}
      {openUserModal && (
        <EditUser
          data={openUserModal}
          form={tableUserCollumns}
          set={set}
          types={userTypes}
          setOpenModal={setOpenUserModal}
        />
      )}
      {openResourceModal && (
        <EditResource
          data={openResourceModal}
          form={tableResourceCollumns}
          set={set}
          types={resourceTypes}
          setOpenModal={setOpenResourceModal}
        />
      )}
    </>
  )
}
